export const OKAPI_TENANT_HEADER = 'X-Okapi-Tenant';
